// src/services/nftFetcher/avalancheNFTFetcher.js
import secureFetch from '../../utils/secureFetch';
import { standardizeNFTFormat } from './nftFormatUtils';
import { fetchContractMetadata } from './contractMetadataFetcher';

/**
 * Fetch NFTs for an Avalanche wallet using the Routescan API.
 * Transforms the response to match the expected format
 *
 * @param {string} walletAddress - The wallet address to query
 * @returns {Promise<Array>} - A promise that resolves to an array of NFT objects
 */
export const fetchNFTs = async (walletAddress) => {
  try {
    const response = await secureFetch(`https://api.routescan.io/v2/network/mainnet/evm/43114/address/${walletAddress}/erc721-holdings?limit=30`);
    const data = await response.json();
    
    // Check if the response has the expected structure
    if (!data || !Array.isArray(data.items)) {
      console.error("Unexpected Avalanche NFT API response format:", data);
      return [];
    }
    
    // Transform the data to match our standardized format
    const nfts = await Promise.all(
      data.items.map(async (item) => {
        try {
          // Create NFT object in Avalanche/Routescan format for standardization
          const nftData = {
            // Avalanche Routescan actual format
            chainId: item.chainId || 43114,
            tokenAddress: item.tokenAddress,
            tokenId: item.tokenId,
            collectionName: item.collectionName,
            collectionSymbol: item.collectionSymbol
          };
          
          // Fetch additional metadata from contract
          const metadata = await fetchContractMetadata(item.tokenAddress, item.tokenId, 'avalanche');
          if (metadata) {
            nftData.metadata = metadata;
          }
          
          return standardizeNFTFormat(nftData, 'avalanche');
        } catch (error) {
          console.error("Error processing Avalanche NFT item:", error, item);
          return null;
        }
      })
    );
    
    const validNFTs = nfts.filter(nft => nft !== null);
    console.log(`Fetched ${validNFTs.length} NFTs for Avalanche address ${walletAddress}`);
    return validNFTs;
    
  } catch (error) {
    console.error("Error fetching Avalanche NFTs:", error);
    return [];
  }
};